import React, { useState } from "react";
import Main from "./Main";
import "primeicons/primeicons.css";

import moment from "moment";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import CreateModal from "./CreateModal";
import { getDocs, collection, orderBy, query, where } from "firebase/firestore";
import { db } from "../firebase/Firebase";
import { useEffect } from "react";

import "./../App.css";
import EditModal from "./EditModal";

import { ProgressBar } from "primereact/progressbar";

//
function Tasks() {
  const localizer = momentLocalizer(moment);

  const [event, setEvent] = useState([]);

  const eventCollectionRef = collection(db, "events");
  const [loading, setLoading] = useState(false);

  const [counter, setCounter] = useState(0);

  useEffect(() => {
    setLoading(true);
    var userValue = JSON.parse(localStorage.getItem("user"));
    const eventQuery = query(
      eventCollectionRef,
      where("userID", "==", userValue.uid)
      // where equal to this month
    );
    const getEventList = async () => {
      try {
        const data = await getDocs(eventQuery);

        const filteredData = data.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          // created_at: doc.data().created_at?.toDate().toLocaleString(),
        }));

        // console.log(filteredData);
        setEvent(filteredData);
        setLoading(false);
        // console.log(filteredData);
      } catch (error) {
        // console.log(error);
        setLoading(false);
      }
    };
    getEventList();
  }, [counter]);

  const [showModal, setShowModal] = useState(false);
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const handleSelectSlot = ({ start, end }) => {
    const originalEnd = new Date(end);
    const convertedEnd = originalEnd.toISOString().slice(0, 16);

    setStart(convertedEnd);
    setEnd(convertedEnd);
    setShowModal(true);
  };

  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState();

  const handleSelectEvent = (event) => {
    // console.table(event);
    // alert(event['title'])
    setShowEdit(true);
    setEditData(event);
  };

  return (
    <>
      <CreateModal
        showModal={showModal}
        setShowModal={setShowModal}
        start={start}
        end={end}
        setCounter={setCounter}
        counter={counter}
      />
      <Main />
      <EditModal
        editData={editData}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
        setCounter={setCounter}
        counter={counter}
      />

      {loading && (
        <div className="card">
          <ProgressBar
            mode="indeterminate"
            style={{ height: "3px" }}
          ></ProgressBar>
        </div>
      )}

      <div style={{ padding: "14px" }}>
        <Calendar
          localizer={localizer}
          events={event}
          showAllEvents={true}
          scrollToTime={true}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 1100 }}
          eventPropGetter={(event) => ({
            style: {
              backgroundColor: event.color,
            },
          })}
          onSelectSlot={handleSelectSlot} // Add this prop
          onSelectEvent={handleSelectEvent}
          views={[Views.MONTH, Views.AGENDA]}
          selectable
        />
      </div>
    </>
  );
}

export default Tasks;
